"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _QuestionTabs = require("./QuestionTabs");
Object.keys(_QuestionTabs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QuestionTabs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _QuestionTabs[key];
    }
  });
});